module.exports = __webpack_public_path__ + "img/assignment_turned_in_outlined.480a8ddf.svg";